declare namespace $ {

	type $mol_string__value_bog_quiz_editor_1 = $mol_type_enforce<
		ReturnType< $bog_quiz_editor['quiz_title_value'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__hint_bog_quiz_editor_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_button_major__click_bog_quiz_editor_3 = $mol_type_enforce<
		ReturnType< $bog_quiz_editor['add_question'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_major__title_bog_quiz_editor_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_list__rows_bog_quiz_editor_5 = $mol_type_enforce<
		ReturnType< $bog_quiz_editor['question_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_section__title_bog_quiz_editor_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_section['title'] >
	>
	type $mol_section__content_bog_quiz_editor_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_section['content'] >
	>
	type $mol_button_major__click_bog_quiz_editor_8 = $mol_type_enforce<
		ReturnType< $bog_quiz_editor['start_session'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_major__title_bog_quiz_editor_9 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_row__sub_bog_quiz_editor_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_row['sub'] >
	>
	type $mol_textarea__value_bog_quiz_editor_11 = $mol_type_enforce<
		ReturnType< $bog_quiz_editor['question_text'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_textarea__hint_bog_quiz_editor_12 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_textarea['hint'] >
	>
	type $mol_switch__value_bog_quiz_editor_13 = $mol_type_enforce<
		ReturnType< $bog_quiz_editor['question_type'] >
		,
		ReturnType< $mol_switch['value'] >
	>
	type $mol_switch__options_bog_quiz_editor_14 = $mol_type_enforce<
		({ 
			'single': string,
			'multi': string,
		}) 
		,
		ReturnType< $mol_switch['options'] >
	>
	type $mol_paragraph__title_bog_quiz_editor_15 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_button_minor__click_bog_quiz_editor_16 = $mol_type_enforce<
		ReturnType< $bog_quiz_editor['add_option'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_bog_quiz_editor_17 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_list__rows_bog_quiz_editor_18 = $mol_type_enforce<
		ReturnType< $bog_quiz_editor['option_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_button_minor__click_bog_quiz_editor_19 = $mol_type_enforce<
		ReturnType< $bog_quiz_editor['question_delete'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_bog_quiz_editor_20 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_list__rows_bog_quiz_editor_21 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_check_box__checked_bog_quiz_editor_22 = $mol_type_enforce<
		ReturnType< $bog_quiz_editor['option_correct'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_check_box__title_bog_quiz_editor_23 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_string__value_bog_quiz_editor_24 = $mol_type_enforce<
		ReturnType< $bog_quiz_editor['option_text'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__hint_bog_quiz_editor_25 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_button_minor__click_bog_quiz_editor_26 = $mol_type_enforce<
		ReturnType< $bog_quiz_editor['option_delete'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_bog_quiz_editor_27 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_card__title_bog_quiz_editor_28 = $mol_type_enforce<
		ReturnType< $bog_quiz_editor['question_number'] >
		,
		ReturnType< $mol_card['title'] >
	>
	type $mol_card__Content_bog_quiz_editor_29 = $mol_type_enforce<
		ReturnType< $bog_quiz_editor['Question_content'] >
		,
		ReturnType< $mol_card['Content'] >
	>
	type $mol_row__sub_bog_quiz_editor_30 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_row['sub'] >
	>
	export class $bog_quiz_editor extends $mol_page {
		quiz_title( ): string
		quiz_title_value( next?: string ): string
		Title_field( ): $mol_string
		add_question( next?: any ): any
		Add_question_button( ): $mol_button_major
		question_rows( ): readonly(any)[]
		Questions( ): $mol_list
		Questions_section( ): $mol_section
		start_session( next?: any ): any
		Start_session_button( ): $mol_button_major
		Actions( ): $mol_row
		question_number( id: any): string
		question_text( id: any, next?: string ): string
		Question_text_field( id: any): $mol_textarea
		question_type( id: any, next?: string ): string
		Question_type_switch( id: any): $mol_switch
		Options_label( id: any): $mol_paragraph
		add_option( id: any, next?: any ): any
		Add_option_button( id: any): $mol_button_minor
		option_rows( id: any): readonly(any)[]
		Options_list( id: any): $mol_list
		question_delete( id: any, next?: any ): any
		Question_delete_button( id: any): $mol_button_minor
		Question_content( id: any): $mol_list
		option_correct( id: any, next?: boolean ): boolean
		Option_correct_check( id: any): $mol_check_box
		option_text( id: any, next?: string ): string
		Option_text_field( id: any): $mol_string
		option_delete( id: any, next?: any ): any
		Option_delete_button( id: any): $mol_button_minor
		quiz_id( ): string
		realm( ): $giper_baza_glob
		title( ): ReturnType< $bog_quiz_editor['quiz_title'] >
		body( ): readonly(any)[]
		Question_card( id: any): $mol_card
		Option_row( id: any): $mol_row
	}
	
}

//# sourceMappingURL=editor.view.tree.d.ts.map